"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("epc-web-utils/dom");
var PositionUtils_1 = require("../utils/PositionUtils");
var DomUtils_1 = require("epc-web-utils/dist/DomUtils");
var ShiftDirection;
(function (ShiftDirection) {
    ShiftDirection["LEFT"] = "left";
    ShiftDirection["RIGHT"] = "right";
})(ShiftDirection || (ShiftDirection = {}));
var DropdownPositionUtils = /** @class */ (function () {
    function DropdownPositionUtils(parentWrapper, trigger, content, contentWrapper) {
        var _a;
        this.viewportGutter = 4;
        this.triggerDistance = 12;
        this.trigger = trigger;
        this.parentWrapper = parentWrapper;
        this.content = content;
        this.contentWrapper = contentWrapper;
        this.mainContentWrapper = (_a = PositionUtils_1.findClosestAncestor(contentWrapper, '.fds-main-content')) !== null && _a !== void 0 ? _a : document.querySelector('.fds-main-content');
    }
    // autoPosition(trigger: HTMLElement, wrapper: HTMLElement, content: HTMLElement): void {
    DropdownPositionUtils.prototype.autoPosition = function () {
        var fullscreen = this.isFullScreen(this.parentWrapper);
        if (fullscreen && this.isMobileViewport()) {
            return;
        }
        var matchedParent = PositionUtils_1.findClosestScrollableParent(this.content);
        this.setVerticalPosition(this.mainContentWrapper, this.parentWrapper, this.trigger, this.content, matchedParent);
        this.setHorizontalPosition(this.parentWrapper, this.content, this.contentWrapper, matchedParent);
    };
    DropdownPositionUtils.prototype.teardown = function () {
        dom_1.DomUtils.removeClass(this.parentWrapper, 'fds-position-top');
        dom_1.DomUtils.removeClass(this.parentWrapper, 'fds-position-trigger-offset');
        delete this.parentWrapper.dataset.position;
        this.removePositionSyles([this.content, this.contentWrapper]);
        this.contentWrapper.style.width = '';
    };
    DropdownPositionUtils.prototype.canFlipDown = function (trigger, content, boundsWrapper) {
        return this.getVerticalClipDistanceBottom(trigger, content, boundsWrapper) > 0;
    };
    DropdownPositionUtils.prototype.canFlipUp = function (trigger, content, mainContentWrapper, boundsWrapper) {
        return this.getVerticalClipDistanceTop(trigger, content, mainContentWrapper, boundsWrapper) > 0;
    };
    DropdownPositionUtils.prototype.setVerticalPosition = function (mainContentWrapper, parentWrapper, trigger, content, boundsWrapper) {
        if (this.canFlipDown(trigger, content, boundsWrapper)) {
            return;
        }
        if (this.canFlipUp(trigger, content, mainContentWrapper, boundsWrapper)) {
            this.flipUp(parentWrapper, content);
        }
        else {
            this.flipMiddle(trigger, parentWrapper, content, mainContentWrapper, boundsWrapper);
        }
    };
    DropdownPositionUtils.prototype.checkLeftAndRightEdge = function (parentWrapper, elem, boundsWrapper) {
        var _a, _b;
        var isRTL = this.isRTL();
        var isNavOpen = this.isNavOpen();
        var parentLeftEdge;
        var parentRightEdge;
        if (!boundsWrapper) {
            if (isRTL) {
                parentLeftEdge = this.triggerDistance;
                if (isNavOpen) {
                    parentRightEdge = ((_a = this.mainContentWrapper) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().right) - this.triggerDistance;
                }
                else {
                    parentRightEdge = this.getViewport().width - this.triggerDistance;
                }
            }
            else {
                parentRightEdge = this.getViewport().width - this.triggerDistance;
                if (isNavOpen) {
                    parentLeftEdge = ((_b = this.mainContentWrapper) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().left) + this.triggerDistance;
                }
                else {
                    parentLeftEdge = this.triggerDistance;
                }
            }
        }
        else {
            parentLeftEdge = (boundsWrapper === null || boundsWrapper === void 0 ? void 0 : boundsWrapper.getBoundingClientRect().left) + this.triggerDistance;
            parentRightEdge = (boundsWrapper === null || boundsWrapper === void 0 ? void 0 : boundsWrapper.getBoundingClientRect().right) - this.triggerDistance;
        }
        if (parentLeftEdge > elem.getBoundingClientRect().left) {
            var clippedBy = parentLeftEdge - elem.getBoundingClientRect().left;
            if (parentWrapper.classList.contains('fds-dropdown-right-aligned')) {
                this.shiftElem(elem, isRTL ? ShiftDirection.LEFT : ShiftDirection.RIGHT, isRTL ? clippedBy : -clippedBy);
            }
            else {
                this.shiftElem(elem, isRTL ? ShiftDirection.RIGHT : ShiftDirection.LEFT, isRTL ? -clippedBy : clippedBy);
            }
        }
        if (parentRightEdge < elem.getBoundingClientRect().right) {
            var clippedBy = parentRightEdge - elem.getBoundingClientRect().right;
            if (parentWrapper.classList.contains('fds-dropdown-right-aligned')) {
                this.shiftElem(elem, isRTL ? ShiftDirection.LEFT : ShiftDirection.RIGHT, isRTL ? clippedBy : -clippedBy);
            }
            else {
                this.shiftElem(elem, isRTL ? ShiftDirection.RIGHT : ShiftDirection.LEFT, isRTL ? -clippedBy : clippedBy);
            }
        }
    };
    DropdownPositionUtils.prototype.setHorizontalPosition = function (parentWrapper, content, contentWrapper, boundsWrapper) {
        if (boundsWrapper) {
            var maxDropdownWidth = boundsWrapper.getBoundingClientRect().width - (this.triggerDistance * 2);
            if (maxDropdownWidth < content.getBoundingClientRect().width) {
                content.setAttribute('style', "width: " + maxDropdownWidth + "px");
            }
        }
        contentWrapper.style.width = content.clientWidth + "px";
        this.checkLeftAndRightEdge(parentWrapper, contentWrapper, boundsWrapper);
    };
    DropdownPositionUtils.prototype.flipUp = function (parentWrapper, content) {
        dom_1.DomUtils.addClass(parentWrapper, 'fds-position-top');
        dom_1.DomUtils.addClass(content, 'fds-position-content');
        parentWrapper.dataset.position = 'top';
    };
    DropdownPositionUtils.prototype.flipMiddle = function (trigger, parentWrapper, content, mainContentWrapper, boundsWrapper) {
        this.shiftDown(trigger, content, mainContentWrapper, boundsWrapper);
        dom_1.DomUtils.addClass(parentWrapper, 'fds-position-trigger-offset');
        dom_1.DomUtils.addClass(content, 'fds-position-content');
    };
    DropdownPositionUtils.prototype.shiftDown = function (trigger, content, mainContentWrapper, boundsWrapper) {
        var verticalClipDistance = this.getVerticalClipDistanceTop(trigger, content, mainContentWrapper, boundsWrapper);
        var calcClipDistance = Math.abs(verticalClipDistance) + this.viewportGutter;
        content.style.bottom = "calc(100% - " + calcClipDistance + "px)";
    };
    DropdownPositionUtils.prototype.getVerticalClipDistanceBottom = function (trigger, content, boundsWrapper) {
        var contentHeight = content.offsetHeight;
        var viewportHeight = this.getViewport().height;
        var triggerOrigin = trigger.getBoundingClientRect().bottom;
        var availableVerticalSpace;
        if (boundsWrapper) {
            availableVerticalSpace = (boundsWrapper.getBoundingClientRect().bottom - this.viewportGutter) - triggerOrigin;
        }
        else {
            availableVerticalSpace = (viewportHeight - this.viewportGutter) - (triggerOrigin + (+this.triggerDistance));
        }
        return availableVerticalSpace - contentHeight;
    };
    DropdownPositionUtils.prototype.getVerticalClipDistanceTop = function (trigger, content, mainContentWrapper, boundsWrapper) {
        var contentHeight = content.offsetHeight;
        var triggerOrigin = trigger.getBoundingClientRect().top;
        var pageWrapperOrigin = (boundsWrapper === null || boundsWrapper === void 0 ? void 0 : boundsWrapper.getBoundingClientRect().top) || (mainContentWrapper === null || mainContentWrapper === void 0 ? void 0 : mainContentWrapper.getBoundingClientRect().top) || 0;
        // If the main content wrapper is not scrolled out of view, consider the top of the main content wrapper as the viewport boundary
        var rawVerticalSpace = pageWrapperOrigin > 0 ? triggerOrigin - pageWrapperOrigin : triggerOrigin;
        var availableVerticalSpace = rawVerticalSpace - this.triggerDistance - this.viewportGutter;
        return availableVerticalSpace - contentHeight;
    };
    DropdownPositionUtils.prototype.shiftElem = function (elem, direction, shiftDistance) {
        elem.style[direction] = shiftDistance + "px";
    };
    DropdownPositionUtils.prototype.getViewport = function () {
        return {
            width: Math.max(document.documentElement.clientWidth),
            height: Math.max(document.documentElement.clientHeight)
        };
    };
    DropdownPositionUtils.prototype.removePositionSyles = function (elems) {
        elems.forEach(function (elem) {
            elem.style.top = '';
            elem.style.bottom = '';
            elem.style.left = '';
            elem.style.right = '';
        });
    };
    DropdownPositionUtils.prototype.isFullScreen = function (parentWrapper) {
        return dom_1.DomUtils.hasClass(parentWrapper, 'fds-dropdown-fullscreen');
    };
    DropdownPositionUtils.prototype.isMobileViewport = function () {
        return document.documentElement.clientWidth < 480;
    };
    DropdownPositionUtils.prototype.isRTL = function () {
        return document.documentElement.dir.toLowerCase() === 'rtl';
    };
    DropdownPositionUtils.prototype.isNavOpen = function () {
        return DomUtils_1.hasClass(document.querySelector('body'), 'nav-open');
    };
    return DropdownPositionUtils;
}());
exports.default = DropdownPositionUtils;
